import { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Box from "@cloudscape-design/components/box";
import Icon from "@cloudscape-design/components/icon";
import ToolCard from "./ToolCard";

function ToolUsagePanel({ toolInvocations = [] }) {
  const { t } = useTranslation();
  const toolsEndRef = useRef(null);

  const sortedTools = [...toolInvocations].sort((a, b) => {
    const tsA = typeof a.timestamp === "number" || /^\d+$/.test(a.timestamp) ? Number(a.timestamp) : new Date(a.timestamp).getTime() / 1000;
    const tsB = typeof b.timestamp === "number" || /^\d+$/.test(b.timestamp) ? Number(b.timestamp) : new Date(b.timestamp).getTime() / 1000;
    return tsA - tsB;
  });

  useEffect(() => {
    if (toolsEndRef.current) {
      toolsEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [toolInvocations]);

  return (
    <div className="tool-panel-container">
      <div className="panel-header">
        <h3>{t("conversation.tools.title")}</h3>
        <Box color="text-body-secondary" fontSize="body-s">{toolInvocations.length} tools</Box>
      </div>
      
      <div className="tool-cards" role="log">
        {sortedTools.length === 0 ? (
          <div className="panel-empty-state">
            <Icon name="settings" size="big" />
            <Box color="text-body-secondary">{t("conversation.tools.empty")}</Box>
          </div>
        ) : (
          <>
            {sortedTools.map((tool) => <ToolCard key={tool.event_id} toolInvocation={tool} />)}
            <div ref={toolsEndRef} />
          </>
        )}
      </div>
    </div>
  );
}

export default ToolUsagePanel;
